export default __webpack_public_path__ + "static/blob2-a5eb7309b258b3a600f6c63860e3b3f0.svg";